<template lang="pug">
  el-collapse-item(:title="title")
    div(class="collapseDesc"
      v-for="desc in descList"
      :key="desc") {{desc}}
    slot
</template>

<script>
export default {
  name: 'CollapseItem',
  props: {
    title: String,
    descList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// collapseItem.vue?63853fba